import { select, takeEvery } from 'redux-saga/effects';
import { recordEventCustomOnly } from 'utilities/uTagging';
import { SECTION_FIELDS } from 'components/newAccountSteps/initialStep/sections/PersonalData/constants';
import { COUNTRY_DOCUMENT_TYPE_DNI } from 'constants/multiLanguage';

export const getUserProfileForm = state => state.userProfileForm;

const field = {
    nationality: {
        action: 'click',
        format: 'dropdown',
        element: 'errorNationalityField',
        errorDescription: {
            required: 'validation-nationalityRequired',
        },
        eventCategory: 'onboarding/step1/personalData',
        eventAction: 'clickDropdown',
        eventLabel: 'dropdown - error',
    },
    docNumber: {
        action: 'type',
        format: 'textBox',
        component: 'form',
        element: 'errorIdDocumentField',
        errorDescription: {
            required: 'validation-fieldRequired',
            valid: 'validation-syntaxErrorDocument',
        },
        eventCategory: 'onboarding/step1/personalData',
        eventAction: 'clickTextBox',
        eventLabel: 'textBox - error',
    },
    name: {
        action: 'type',
        format: 'textBox',
        element: 'errorNameField',
        errorDescription: {
            required: 'validation-fieldRequired',
            valid: 'validation-syntaxError',
        },
        eventCategory: 'onboarding/step1/personalData',
        eventAction: 'clickTextBox',
        eventLabel: 'textBox - error',
    },
    lastName: {
        action: 'type',
        format: 'textBox',
        element: 'errorSurname1Field',
        errorDescription: {
            required: 'validation-fieldRequired',
            valid: 'validation-syntaxError',
        },
        eventCategory: 'onboarding/step1/personalData',
        eventAction: 'clickTextBox',
        eventLabel: 'textBox - error',
    },
    secondLastName: {
        action: 'type',
        format: 'textBox',
        element: 'errorSurname2Field',
        errorDescription: {
            required: 'validation-fieldRequired',
            valid: 'validation-syntaxError',
        },
        eventCategory: 'onboarding/step1/personalData',
        eventAction: 'clickTextBox',
        eventLabel: 'textBox - error',
    },
    birthDate: {
        action: 'type',
        format: 'textBox',
        element: 'errorBirthDateField',
        errorDescription: {
            required: 'validation-fieldRequired',
            valid: 'validation-birthDate',
            validYearLength: 'validation-birthdayLength',
        },
        eventCategory: 'onboarding/step1/personalData',
        eventAction: 'clickTextBox',
        eventLabel: 'textBox - error',
    },
    birthDay: {
        action: 'type',
        format: 'textBox',
        element: 'errorDayBirthDateField',
        errorDescription: {
            required: 'validation-fieldRequired',
            valid: 'validation-birthDate',
        },
        eventCategory: 'onboarding/step1/personalData',
        errorCategory: 'errorRequiredField',
        eventAction: 'clickTextBox',
        eventLabel: 'textBox - error',
    },
    birthMonth: {
        action: 'type',
        format: 'textBox',
        element: 'errorMonthBirthDateField',
        errorDescription: {
            required: 'validation-fieldRequired',
            valid: 'validation-birthDate',
        },
        eventCategory: 'onboarding/step1/personalData',
        eventAction: 'clickTextBox',
        eventLabel: 'textBox - error',
    },
    birthYear: {
        action: 'type',
        format: 'textBox',
        element: 'errorYearBirthDateField',
        errorDescription: {
            required: 'validation-fieldRequired',
            valid: 'validation-birthDate',
        },
        eventCategory: 'onboarding/step1/personalData',
        eventAction: 'clickTextBox',
        eventLabel: 'textBox - error',
    },
    resident: {
        action: 'click',
        format: 'radioButton',
        element: 'errorFiscalResidenceField',
        errorDescription: {
            required: 'validation-radioRequired',
        },
        eventCategory: 'onboarding/step1/personalData',
        eventAction: 'clickRadioButton',
        eventLabel: 'radioButton - error',
    },
    tin: {
        action: 'type',
        format: 'textBox',
        element: 'errorTinField',
        errorDescription: {
            required: 'validation-fieldRequired',
            valid: 'validation-text',
        },
        eventCategory: 'onboarding/step1/personalData',
        eventAction: 'clickTextBox',
        eventLabel: 'textBox - error',
    },
    email: {
        action: 'type',
        format: 'textBox',
        element: 'errorEmailField',
        errorDescription: {
            required: 'validation-fieldRequired',
            valid: 'validation-email',
        },
        eventCategory: 'onboarding/step3/validateEmail',
        eventAction: 'clickTextBox',
        eventLabel: 'textBox - error',
    },
    password: {
        action: 'type',
        format: 'textBox',
        element: 'errorAccessKeyField',
        eventCategory: 'onboarding/step4/accessKey',
        errorDescription: {
            required: 'validation-fieldRequired',
        },
        eventAction: 'clickTextBox',
        eventLabel: 'textBox - error',
    },
};

const errorCategory = {
    required: 'errorRequiredField',
    valid: 'errorInvalidFormat',
    validYearLength: 'errorBirthDateLenght',
    older: 'errorOlderBirthDate',
};

const isDocumentTypeDNI = documentType => documentType === COUNTRY_DOCUMENT_TYPE_DNI;
const isSecondLastNameRequired = documentType => (isDocumentTypeDNI(documentType) ? ['secondLastName'] : []);

function* doTagRequiredFields(action) {
    const userProfileForm = yield select(getUserProfileForm);
    const requiredFields = [
        ...SECTION_FIELDS,
        'birthDate',
        'tin',
        'email',
        'password',
        ...isSecondLastNameRequired(userProfileForm?.documentType?.value),
    ];
    const requiredField = requiredFields.find(field => `userProfile.${field}` === action.model);
    const errors = userProfileForm[requiredField]?.errors;
    const [errorType, isError] = Object.entries(errors || {}).find(([, value]) => !!value) || [];

    if (isError) {
        recordEventCustomOnly({
            action: field[requiredField].action,
            format: field[requiredField].format,
            component: 'form',
            element: field[requiredField].element,
            errorCategory: errorCategory[errorType],
            errorDescription: field[requiredField].errorDescription[errorType],
            eventCategory: field[requiredField].eventCategory,
            eventAction: field[requiredField].eventAction,
            eventLabel: field[requiredField].eventLabel,
        });
    }
}

function* errorTagging() {
    yield takeEvery('rrf/setValidity', doTagRequiredFields);
}

export default errorTagging;
